(function () {
  'use strict';

  var sectionSelector = '[data-cart-drawer-section]';
  var sectionId = 'cart-drawer';
  var previousFocus = null;
  var drawerWasOpen = false;
  var israelOnlyMessage = 'This CD is not available for delivery in your country. Remove it to continue. Other products can still ship to your country.';

  function getSection() {
    return document.querySelector(sectionSelector);
  }

  function getRoute(name, fallback) {
    var section = getSection();
    return section && section.getAttribute(name) ? section.getAttribute(name) : fallback;
  }

  function getMarketCountry() {
    var section = getSection();
    return section ? (section.getAttribute('data-market-country') || '').toUpperCase() : '';
  }

  function isIsraelOnlyVariant(variantId) {
    var section = getSection();
    if (!section || variantId == null) return false;
    var restrictedIds = (section.getAttribute('data-israel-only-variant-ids') || '').split(',');
    return restrictedIds.indexOf(String(variantId)) !== -1;
  }

  function getErrorMessage(payload, fallback) {
    if (!payload) return fallback;
    return payload.description || payload.message || fallback;
  }

  function parseResponse(response) {
    return response.json().catch(function () {
      return {};
    }).then(function (payload) {
      if (!response.ok) {
        throw new Error(getErrorMessage(payload, 'The cart could not be updated. Please try again.'));
      }
      return payload;
    });
  }

  function setLoading(isLoading) {
    var section = getSection();
    if (!section) return;
    section.setAttribute('data-loading', isLoading ? 'true' : 'false');
    section.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function setDrawerError(message) {
    var section = getSection();
    if (!section) return;
    var error = section.querySelector('[data-cart-drawer-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function announce(message) {
    var section = getSection();
    if (!section) return;
    var status = section.querySelector('[data-cart-drawer-status]');
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 20);
  }

  function updateCartCount() {
    var section = getSection();
    if (!section) return;
    var count = Number(section.getAttribute('data-cart-drawer-item-count')) || 0;

    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
    });

    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (node) {
      node.classList.toggle('hide', count === 0);
    });
  }

  function replaceSection(html) {
    if (!html) {
      throw new Error('The cart could not be refreshed. Please reload the page.');
    }

    var container = document.createElement('div');
    container.innerHTML = html;
    var nextSection = container.querySelector(sectionSelector);
    var currentSection = getSection();

    if (!nextSection || !currentSection) {
      throw new Error('The cart could not be refreshed. Please reload the page.');
    }

    currentSection.replaceWith(nextSection);
    updateCartCount();
  }

  function getFocusableElements() {
    var section = getSection();
    if (!section) return [];
    return Array.prototype.slice.call(section.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetParent !== null && element.tabIndex >= 0 && !element.hasAttribute('hidden');
    });
  }

  function setCartTriggersExpanded(isExpanded) {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin === window.location.origin && /\/cart\/?$/.test(url.pathname) && !link.closest(sectionSelector)) {
        link.setAttribute('aria-controls', 'MiskoCartDrawerDialog');
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    });
  }

  function openDrawer(options) {
    var section = getSection();
    if (!section) return;

    if (!drawerWasOpen) {
      previousFocus = options && options.focusSource ? options.focusSource : document.activeElement;
    }

    drawerWasOpen = true;
    section.removeAttribute('inert');
    section.setAttribute('aria-hidden', 'false');
    section.setAttribute('data-open', 'true');
    document.documentElement.classList.add('misko-cart-drawer-open');
    setCartTriggersExpanded(true);

    if (!options || options.focus !== false) {
      window.setTimeout(function () {
        var closeButton = getSection() && getSection().querySelector('.misko-cart-drawer__close');
        if (closeButton) closeButton.focus();
      }, 30);
    }
  }

  function closeDrawer(options) {
    var section = getSection();
    if (!section) return;

    drawerWasOpen = false;
    section.setAttribute('aria-hidden', 'true');
    section.setAttribute('data-open', 'false');
    section.setAttribute('inert', '');
    document.documentElement.classList.remove('misko-cart-drawer-open');
    setCartTriggersExpanded(false);

    if ((!options || options.restoreFocus !== false) && previousFocus && document.contains(previousFocus)) {
      previousFocus.focus();
    }
    previousFocus = null;
  }

  function showFormError(form, message) {
    var wrapper = form.querySelector('[data-error-message-wrapper]');
    var target = form.querySelector('[data-error-message]');

    if (wrapper && target) {
      target.textContent = message;
      wrapper.classList.remove('product-form__error-message-wrapper--hidden');
      wrapper.removeAttribute('aria-hidden');
      return;
    }

    var error = form.querySelector('[data-cart-form-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'misko-cart-drawer__form-error';
      error.setAttribute('data-cart-form-error', '');
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.textContent = message;
  }

  function clearFormError(form) {
    var wrapper = form.querySelector('[data-error-message-wrapper]');
    if (wrapper) wrapper.classList.add('product-form__error-message-wrapper--hidden');
    var error = form.querySelector('[data-cart-form-error]');
    if (error) error.remove();
  }

  function isCartAddForm(form) {
    if (!form || !form.action) return false;
    try {
      var url = new URL(form.action, window.location.origin);
      return url.origin === window.location.origin && /\/cart\/add\/?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function isAcceleratedCheckout(submitter) {
    return submitter && Boolean(submitter.closest('.shopify-payment-button'));
  }

  function getBundleItems(bundle) {
    var items = [];
    var upgrade = bundle.querySelector('[data-ams-upgrade-item]:checked');
    var productSection = bundle.closest('[data-section-type="product"]');
    var productForm = productSection && productSection.querySelector('form[action*="/cart/add"]');
    var currentVariant = productForm && productForm.querySelector('[name="id"]');

    if (upgrade && upgrade.value) {
      items.push({ id: String(upgrade.value), quantity: 1 });
    } else if (currentVariant && currentVariant.value) {
      items.push({ id: String(currentVariant.value), quantity: 1 });
    }

    bundle.querySelectorAll('[data-ams-bundle-item]:checked').forEach(function (input) {
      if (input.value) items.push({ id: String(input.value), quantity: 1 });
    });

    return items;
  }

  function showBundleStatus(bundle, message) {
    var status = bundle.querySelector('[data-ams-bundle-status]');
    if (status) status.textContent = message || '';
  }

  function getCart() {
    return fetch(getRoute('data-cart-url', '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(parseResponse);
  }

  function filterDuplicateDigitalItems(bundle, items, cart) {
    var isDigital = bundle.getAttribute('data-active-category') === 'digital' ||
      bundle.getAttribute('data-ams-bundle-type') === 'tabs';
    if (!isDigital) return { items: items, skippedCount: 0 };

    var existing = {};
    var selected = {};
    (cart.items || []).forEach(function (item) {
      existing[String(item.variant_id)] = true;
    });

    var filtered = items.filter(function (item) {
      var id = String(item.id);
      if (existing[id] || selected[id]) return false;
      selected[id] = true;
      return true;
    });

    return { items: filtered, skippedCount: items.length - filtered.length };
  }

  function addBundleToCart(bundle, button, items) {
    var originalLabel = button.textContent;
    var productSection = bundle.closest('[data-section-type="product"]');
    var productForm = productSection && productSection.querySelector('form[action*="/cart/add"]');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding...';
    showBundleStatus(bundle, '');
    if (productForm) clearFormError(productForm);

    getCart()
      .then(function (cart) {
        var filtered = filterDuplicateDigitalItems(bundle, items, cart);
        if (!filtered.items.length) {
          throw new Error('These digital downloads are already in your cart.');
        }

        return fetch(getRoute('data-cart-add-url', '/cart/add') + '.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: filtered.items,
            sections: [sectionId],
            sections_url: window.location.pathname
          }),
          credentials: 'same-origin'
        })
          .then(parseResponse)
          .then(function (payload) {
            replaceSection(payload.sections && payload.sections[sectionId]);
            openDrawer({ focusSource: button });
            announce(filtered.skippedCount ?
              'Items added. Digital downloads already in your cart were not added again.' :
              'Item added to cart.');
          });
      })
      .catch(function (error) {
        showBundleStatus(bundle, error.message || 'Could not add this bundle. Please try again.');
      })
      .finally(function () {
        if (document.contains(button)) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
        }
      });
  }

  function handleBundleAdd(event) {
    var bundleButton = event.target.closest('.ams-native-bundle__button');
    if (!bundleButton) return;

    var bundle = bundleButton.closest('[data-ams-bundle]');
    var section = getSection();
    if (!bundle || !section) return;

    var items = getBundleItems(bundle);
    if (!items.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (getMarketCountry() !== 'IL' && items.some(function (item) {
      return isIsraelOnlyVariant(item.id);
    })) {
      var productSection = bundle.closest('[data-section-type="product"]');
      var form = productSection && productSection.querySelector('form[action*="/cart/add"]');
      if (form) {
        clearFormError(form);
        showFormError(form, israelOnlyMessage);
      } else {
        showBundleStatus(bundle, israelOnlyMessage);
      }
      return;
    }

    addBundleToCart(bundle, bundleButton, items);
  }

  function addToCart(form, submitter) {
    var formData = new FormData(form);

    if (isIsraelOnlyVariant(formData.get('id')) && getMarketCountry() !== 'IL') {
      clearFormError(form);
      showFormError(form, israelOnlyMessage);
      return;
    }

    formData.set('sections', sectionId);
    formData.set('sections_url', window.location.pathname);

    if (submitter && submitter.name && !formData.has(submitter.name)) {
      formData.append(submitter.name, submitter.value || '');
    }

    clearFormError(form);
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }

    fetch(getRoute('data-cart-add-url', '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin'
    })
      .then(parseResponse)
      .then(function (payload) {
        replaceSection(payload.sections && payload.sections[sectionId]);
        openDrawer({ focusSource: submitter || form });
        announce('Item added to cart.');
      })
      .catch(function (error) {
        showFormError(form, error.message);
      })
      .finally(function () {
        if (submitter && document.contains(submitter)) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
      });
  }

  function changeCartLine(line, quantity) {
    var section = getSection();
    if (!section) return;

    setLoading(true);
    setDrawerError('');

    fetch(getRoute('data-cart-change-url', '/cart/change') + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: Number(line),
        quantity: Math.max(0, Number(quantity) || 0),
        sections: [sectionId],
        sections_url: window.location.pathname
      }),
      credentials: 'same-origin'
    })
      .then(parseResponse)
      .then(function (payload) {
        replaceSection(payload.sections && payload.sections[sectionId]);
        openDrawer({ focus: false });
        announce('Cart updated.');
      })
      .catch(function (error) {
        setDrawerError(error.message);
      })
      .finally(function () {
        setLoading(false);
      });
  }

  document.addEventListener('click', handleBundleAdd, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isCartAddForm(form) || isAcceleratedCheckout(event.submitter)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(form, event.submitter || document.activeElement);
  }, true);

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-cart-drawer-close]');
    if (closeButton) {
      if (closeButton.tagName === 'A' && closeButton.href) {
        closeDrawer({ restoreFocus: false });
        return;
      }
      event.preventDefault();
      closeDrawer();
      return;
    }

    var changeButton = event.target.closest('[data-cart-drawer-change]');
    if (changeButton) {
      event.preventDefault();
      changeCartLine(changeButton.getAttribute('data-line'), changeButton.getAttribute('data-quantity'));
      return;
    }

    var removeButton = event.target.closest('[data-cart-drawer-remove]');
    if (removeButton) {
      event.preventDefault();
      changeCartLine(removeButton.getAttribute('data-line'), 0);
      return;
    }

    var link = event.target.closest('a[href]');
    if (!link || link.closest(sectionSelector) || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && /\/cart\/?$/.test(url.pathname)) {
        event.preventDefault();
        openDrawer({ focusSource: link });
      }
    } catch (error) {
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-drawer-quantity]');
    if (!input) return;
    changeCartLine(input.getAttribute('data-line'), input.value);
  });

  document.addEventListener('keydown', function (event) {
    if (!drawerWasOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = getFocusableElements();
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCartCount();
    setCartTriggersExpanded(false);
  });

  window.MiskoCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refreshCount: updateCartCount
  };
})();
